import { cn } from 'src/shared/utils/cn'

type CornerConfig = {
  tl?: boolean
  tr?: boolean
  bl?: boolean
  br?: boolean
}

type BCImageGridProps = {
  images: string[]
  className?: string
  onImageClick?: (index: number) => void
}

const getCornerClasses = ({ tl, tr, bl, br }: CornerConfig) =>
  cn(
    'rounded-[4px]',
    tl && 'rounded-tl-[15px]',
    tr && 'rounded-tr-[15px]',
    bl && 'rounded-bl-[15px]',
    br && 'rounded-br-[15px]',
  )

const GridImage = ({
  src,
  index,
  className,
  onImageClick,
}: {
  src: string
  index: number
  className?: string
  onImageClick?: (index: number) => void
}) => {
  return (
    <img
      src={src}
      alt={`Image ${index + 1}`}
      className={cn('size-full object-cover', className)}
      onClick={() => onImageClick?.(index)}
    />
  )
}

const BCImageGrid = ({ images, className, onImageClick }: BCImageGridProps) => {
  const items = images.slice(0, 3)

  if (items.length === 0) return null

  if (items.length === 1) {
    return (
      <div className={cn('h-[270px] w-full overflow-hidden rounded-[15px]', className)}>
        <GridImage src={items[0]} index={0} className="rounded-[15px]" onImageClick={onImageClick} />
      </div>
    )
  }

  if (items.length === 2) {
    return (
      <div className={cn('flex h-[270px] w-full gap-[6px] overflow-hidden rounded-[15px]', className)}>
        <div className="flex-1">
          <GridImage
            src={items[0]}
            index={0}
            className={getCornerClasses({ tl: true, bl: true })}
            onImageClick={onImageClick}
          />
        </div>
        <div className="flex-1">
          <GridImage
            src={items[1]}
            index={1}
            className={getCornerClasses({ tr: true, br: true })}
            onImageClick={onImageClick}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={cn('flex h-[270px] w-full gap-[6px] overflow-hidden rounded-[15px]', className)}>
      <div className="w-3/5">
        <GridImage
          src={items[0]}
          index={0}
          className={getCornerClasses({ tl: true, bl: true })}
          onImageClick={onImageClick}
        />
      </div>
      <div className="flex w-2/5 flex-col gap-[6px]">
        <div className="flex-1">
          <GridImage src={items[1]} index={1} className={getCornerClasses({ tr: true })} onImageClick={onImageClick} />
        </div>
        <div className="flex-1">
          <GridImage src={items[2]} index={2} className={getCornerClasses({ br: true })} onImageClick={onImageClick} />
        </div>
      </div>
    </div>
  )
}

export default BCImageGrid
